import React from 'react'
import '../../styles/User/directions.css'
import { airportCodes } from '../../data/airportCodes'
import TopBar from '../../components/User/TopBar'
import ReactGA from 'react-ga';

function Directions() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div className='directions'>
        <TopBar />
        <div className="main-page">
            <div className="head">
                <h1 className='heading'>Directions</h1>
                <p className="info">Click airport location to map directions</p>
                <p className="note"><span>Note</span>: In order to get directions to the parking facilities, you would have to click "Get Direction" and enter the address of the facilities in the associated Google map or Mapquest map for the respective airport.</p>
            </div>
            <table className="codes">
                <thead>
                    <tr>
                        <th>Airport Code</th>
                        <th>Airport</th>
                        <th>Directions</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        airportCodes.map(airport => {
                            return (
                                <tr>
                                    <td>{airport.code}</td>
                                    <td>{airport.name}</td>
                                    <td>
                                        <div className="links">
                                            <a href={airport.googleLink} className='google-link' rel='noreferrer' target='_blank'>Google Map</a>
                                            <a href={airport.mapquestLink} className='mapquest-link' rel='noreferrer' target='_blank'>MapQuest</a>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    </div>
  )
}

export default Directions